<template>
	<section class="stepper-component">
		<div class="content-devx">
			<div class="card-header">
				{{ title }}
			</div>
			<div class="card-body">
				<section class="steps content-separatos">
					<div
						v-for="(step, index) in nutritionSteps"
						:key="index"
						:class="'step ' + getCompleteClassStatus(step)"
						@click="setCurrentStep(index)">
						<div class="dot-container">
							<span :class="'dot ' + step.statusClass">
								<i
									v-if="
										step.statusClass && step.statusClass.includes('complete')
									"
									class="dx-icon-check" />
							</span>
						</div>
						<span class="dot-label">
							<span class="dot-label-main">{{ step.label }}</span>
							<span v-if="step.sublabel" class="dot-sublabel">{{ step.sublabel }}</span>
						</span>
					</div>
				</section>
				<section
					v-if="stepIndex === 0"
					class="data-form margin-top content-separatos">
					<f7-row class="margin-bottom-block">
						<f7-col>
							<div class="dx-field">
								<div class="mb-2" style="font-weight: 500">
									{{ $t('Utilities.stepperForm.planDescription') }}
									<span style="color: red">*</span>
								</div>
								<div>
									<DxTextBox v-model="stepData.planDescription" />
								</div>
							</div>
						</f7-col>
						<f7-col v-if="isNew">
							<div class="dx-field">
								<div class="mb-2" style="font-weight: 500">
									{{ $t('Utilities.stepperForm.ph') }}
									<span style="color: red">*</span>
								</div>
								<div>
									<DxNumberBox
										:value="stepData.ph"
										@value-changed="phChanged" />
								</div>
							</div>
						</f7-col>
						<f7-col>
							<div class="dx-field">
								<div class="mb-2" style="font-weight: 500">
									{{ $t('Utilities.stepperForm.temporalFrame') }}
									<span style="color: red">*</span>
								</div>
								<div>
									<DxSelectBox
										v-model="temporalFrameId"
										display-expr="label"
										value-expr="id"
										:items="temporalFrameItems"
										:disabled="isEditing || isCopying"
										@value-changed="updateTemporalFrame" />
								</div>
							</div>
						</f7-col>
						<f7-col>
							<div class="dx-field">
								<div class="mb-2" style="font-weight: 500">
									{{ $t('dates') }}
									<span style="color: red">*</span>
								</div>
								<div>
									<f7-input
										:key="datePickerKey || `input-${temporalFrameId}`"
										type="datepicker"
										class="double-date-picker"
										:placeholder="
											$t('PlanningComponent_datepicker_multiple_placeholder')
										"
										:clear-button="true"
										:close-on-select="true"
										:calendar-params="calendarParamsComputed"
										@calendar:change="calendarChange" />
								</div>
							</div>
						</f7-col>
					</f7-row>
					<div class="bottom" />
				</section>
				<section v-if="false" class="data-form-label">
					<div class="top">
						<div class="dx-field">
							<div class="dx-field-label">
								{{ $t('Utilities.stepperForm.planDescription') }}
							</div>
							<div class="dx-field-value">
								{{ stepData.planDescription }}
							</div>
						</div>
						<div class="dx-field">
							<div class="dx-field-label">
								{{ $t('Utilities.stepperForm.temporalFrame') }}
							</div>
							<div class="dx-field-value">
								{{ stepData.temporalFrame.label }}
							</div>
						</div>
					</div>
					<div class="bottom">
						<div class="dx-field">
							<div class="dx-field-label">
								{{ $t('Utilities.stepperForm.init') }}
							</div>
							<div class="dx-field-value">
								{{ formatInitDate() }}
							</div>
						</div>
						<div class="dx-field">
							<div class="dx-field-label">
								{{ $t('Utilities.stepperForm.end') }}
							</div>
							<div class="dx-field-value">
								{{ formatEndDate() }}
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</section>
</template>
<script>
	import { mapState, mapActions } from 'vuex';
	import { DxDateBox, DxCalendarOptions } from 'devextreme-vue/date-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import moment from 'moment';
	import { getTimeValues } from '../../../js/utils/timeValuesUtils';

	export default {
		name: 'Stepper',
		components: {
			DxNumberBox,
			DxDateBox,
			DxCalendarOptions,
			DxSelectBox,
			DxTextBox,
		},
		props: [],
		data() {
			return {
				title: this.$t('Register_fertilization_plan'),
				stepSelected: {},
				temporalFrameId: 0,
				temporalFrameItems: [
					{
						id: 0,
						label: this.$t('Utilities.stepperForm.monthly'),
						value: 'MENSUAL',
					},
					{
						id: 1,
						label: this.$t('Utilities.stepperForm.weekly'),
						value: 'SEMANAL',
					},
					{
						id: 2,
						label: this.$t('Utilities.stepperForm.daily'),
						value: 'DIARIO',
					},
				],
				initDateNut: null,
				endDateNut: null,
				datePickerKey: 0,
			};
		},
		computed: {
			...mapState('nutritionStepper', [
				'nutritionSteps',
				'stepData',
				'currentStep',
				'stepIndex',
				'enableWatchers',
				'isEditing',
				'editingStepData',
				'isCopying',
				'copyingStepData',
				'isCopying',
				'isNew',
			]),
			...mapState('Plantation', ['currentPlantation']),
			dateboxFormat() {
				return this.temporalFrameId === 0 ? 'MM/yyyy' : 'dd/MM/yyyy';
			},
			dateboxFormatF7() {
				return this.temporalFrameId === 0 ? 'mm/yyyy' : 'dd/mm/yyyy';
			},
			maxZoomLevel() {
				return ['year', 'month'][this.temporalFrameId];
			},
			calendarParamsComputed() {
				const params = {
					closeOnSelect: true,
					rangePicker: true,
					monthPicker: true,
					dateFormat: this.dateboxFormatF7,
					disabled: this.disabledDatesf7,
				};
				// Solo incluir 'value' si hay fechas seleccionadas
				if (this.initDateNut || this.endDateNut) {
					params.value = [this.initDateNut, this.endDateNut];
				}
				return params;
			},
		},
		beforeMount() {
			this.updateClasses();
			this.initData();

			// Si es una plantación de tipo HERBÁCEO, se elimina el marco temporal DIARIO.
			if (this.currentPlantation.crop_type === 'HERBÁCEO') {
				this.temporalFrameItems = this.temporalFrameItems.filter(
					(item) => item.value !== 'DIARIO',
				);
			}

			if (!this.stepData.temporalFrame) {
				this.setStepDataTemporalFrame(this.temporalFrameItems[0]);
			} else {
				this.temporalFrameId = this.stepData.temporalFrame.id;
				// Se vuelve a asignar el marco temporal para añadir la traducción correcta.
				this.setStepDataTemporalFrame(
					this.temporalFrameItems[this.temporalFrameId],
				);
			}
			if (!this.stepData.initDate) {
				this.initDateNut = null;
				this.endDateNut = null;
			} else {
				this.initDateNut = this.stepData.initDate
					? new Date(this.stepData.initDate)
					: null;
				this.endDateNut = this.stepData.endDate
					? new Date(this.stepData.endDate)
					: null;
			}
		},
		methods: {
			phChanged(e) {
				const value = parseFloat((parseFloat(e.value) || 0).toFixed(1));
				const ph = Math.min(Math.max(value, 0), 14);
				this.stepData.ph = ph;
			},
			disabledDates(args) {
				const actualDate = moment(args.date, 'YYYY-MM-DD');
				const initDate = moment(this.currentPlantation.initDate, 'YYYY-MM-DD');
				const endDate = moment(this.currentPlantation.endDate, 'YYYY-MM-DD');

				if (args.view === 'month') {
					return !actualDate.isBetween(initDate, endDate, 'days', '[]');
				}

				if (args.view === 'year') {
					return !actualDate.isBetween(initDate, endDate, 'months', '[]');
				}

				if (args.view === 'decade') {
					return !actualDate.isBetween(initDate, endDate, 'years', '[]');
				}

				if (args.view === 'century') {
					const exactYear = parseInt(actualDate.year() / 10) * 10;
					const initDateIsBetween =
						initDate.year() >= exactYear && initDate.year() <= exactYear + 9;
					const endDateIsBetween =
						endDate.year() >= exactYear && endDate.year() <= exactYear + 9;

					return !(initDateIsBetween || endDateIsBetween);
				}

				return false;
			},
			formatInitDate() {
				return moment(this.stepData.initDate).format('MM/yyyy');
			},
			formatEndDate() {
				return moment(this.stepData.endDate).format('MM/yyyy');
			},
			setCurrentStep(index) {
				this.setStep(index);
				this.$f7.views.main.router.navigate(this.currentStep.page, {
					reloadCurrent: true,
				});
			},
			initData() {
				if (!this.enableWatchers) {
					return;
				}

				if (this.isEditing) {
					let { timeValues } = getTimeValues(
						moment(this.stepData.initDate),
						moment(this.stepData.endDate),
						this.stepData.temporalFrame.value,
					);
					const newTimeValues = [];

					this.editingStepData.timeValues.forEach((item, index) => {
						newTimeValues[index] = {};
						Object.entries(timeValues[0]).forEach(([key, value]) => {
							const numberOfItems =
								Object.values(newTimeValues[index] || {}).length ?? 0;
							newTimeValues[index][key] =
								Object.values(item)[numberOfItems] ?? 0;
						});
					});

					const extraTimeValues = Math.max(
						0,
						this.stepData.timeValues.length -
							this.editingStepData.timeValues.length,
					);

					// for (let i = 0; i < extraTimeValues; i++) {
					//   newTimeValues.push(timeValuePeriods);
					// }

					this.stepData.timeValues = newTimeValues;
					return;
				}

				if (this.isCopying) {
					if (this.copyingStepData.timeValues.length === 0) {
						this.stepData.initDate = this.copyingStepData.initDate;
						this.stepData.endDate = this.copyingStepData.endDate;
						this.copyingStepData.timeValues = this.stepData.timeValues;
					}

					let { timeValues } = getTimeValues(
						moment(this.stepData.initDate),
						moment(this.stepData.endDate),
						this.stepData.temporalFrame.value,
					);
					const newTimeValues = [];

					this.copyingStepData.timeValues.forEach((item, index) => {
						newTimeValues[index] = {};
						Object.entries(timeValues[0]).forEach(([key, value]) => {
							const numberOfItems =
								Object.values(newTimeValues[index] || {}).length ?? 0;
							newTimeValues[index][key] =
								Object.values(item)[numberOfItems] ?? 0;
						});
					});

					const extraTimeValues = Math.max(
						0,
						this.stepData.timeValues.length -
							this.copyingStepData.timeValues.length,
					);

					// for (let i = 0; i < extraTimeValues; i++) {
					//   newTimeValues.push(timeValuePeriods);
					// }

					this.stepData.timeValues = newTimeValues;
					return;
				}

				if (
					!this.stepData.initDate ||
					!this.stepData.endDate ||
					!this.stepData.temporalFrame.value
				)
					return;

				const { timeValues } = getTimeValues(
					moment(this.stepData.initDate),
					moment(this.stepData.endDate),
					this.stepData.temporalFrame.value,
				);
				const newTimeValues = [];
				this.stepData.timeValues.forEach((item, index) => {
					newTimeValues[index] = {};
					Object.entries(timeValues[0]).forEach(([key, value]) => {
						const numberOfItems =
							Object.values(newTimeValues[index] || {}).length ?? 0;
						newTimeValues[index][key] = Object.values(item)[numberOfItems] ?? 0;
					});
				});

				this.stepData.timeValues = newTimeValues;
				// this.stepData.nutritionalBalanceData = [];
				// this.stepData.timeValues = [];
				// this.stepData.dosages = [];
				// this.stepData.dosageProduct = [];
				// this.stepData.dosageProductBalance = [];
				// this.stepData.productResume = [];
			},
			getCompleteClassStatus(step) {
				if (!step || !step.statusClass) {
					return 'no-pointer-event';
				}
				return !step.statusClass.includes('complete') ? 'no-pointer-event' : '';
			},
			updateTemporalFrame({ value }) {
				this.initData();
				this.setStepDataTemporalFrame(this.temporalFrameItems[value]);

				// Si se selecciona DIARIO y hay una fecha de inicio seleccionada, ajustar el rango automáticamente
				if (
					this.temporalFrameItems[value].value === 'DIARIO' &&
					this.initDateNut
				) {
					const plantationEnd = moment(
						this.currentPlantation.endDate,
						'YYYY-MM-DD',
					);
					let start = moment(this.initDateNut, 'YYYY-MM-DD');
					let end = start.clone().add(30, 'days');
					if (end.isAfter(plantationEnd)) {
						end = plantationEnd;
					}
					this.endDateNut = end.toDate(); // Siempre guardar como Date
					this.stepData.initDate = start;
					this.stepData.endDate = end;
				}
			},
			disabledDatesf7(date) {
				const initDatePlantation = moment(
					this.currentPlantation.initDate,
					'YYYY-MM-DD',
				);
				const endDatePlantation = moment(
					this.currentPlantation.endDate,
					'YYYY-MM-DD',
				);

				return !moment(date).isBetween(
					initDatePlantation,
					endDatePlantation,
					'days',
					'[]',
				);
			},
			calendarChange(e) {
				let start = e[0] ? new Date(e[0]) : null;
				let end = e[1] ? new Date(e[1]) : null;

				if (this.shouldClearSelection(start, end)) {
					this.clearDateSelection();
					return;
				}

				// Guardar valores previos para comparar
				const prevStart = this.initDateNut ? this.initDateNut.getTime() : null;
				const prevEnd = this.endDateNut ? this.endDateNut.getTime() : null;

				let showAlert = false;
				if (this.shouldLimitDailyRange(start, end)) {
					const [limitedStart, limitedEnd] = this.limitDailyRange(start, end);
					// Solo mostrar el alert si el usuario ha cambiado el rango y se ha limitado
					if (
						(start.getTime() !== limitedStart.getTime() ||
							end.getTime() !== limitedEnd.getTime()) &&
						(start.getTime() !== prevStart || end.getTime() !== prevEnd)
					) {
						showAlert = true;
					}
					[start, end] = [limitedStart, limitedEnd];
				}

				this.assignDates(start, end);

				if (this.shouldRecalculateIrrigation(start, end)) {
					this.recalculateIrrigation(start, end);
				}

				if (start && end) {
					this.initData();
				}

				if (showAlert) {
					this.$f7.dialog.alert(
						'El rango de 31 días para el marco temporal DIARIO ha sido superado.',
					);
				}
			},

			shouldClearSelection(start, end) {
				return !start && !end;
			},

			clearDateSelection() {
				this.initDateNut = null;
				this.endDateNut = null;
				this.stepData.initDate = null;
				this.stepData.endDate = null;
			},

			shouldLimitDailyRange(start, end) {
				return start && end && this.temporalFrameId === 2;
			},

			limitDailyRange(start, end) {
				const plantationStart = moment(
					this.currentPlantation.initDate,
					'YYYY-MM-DD',
				);
				const plantationEnd = moment(
					this.currentPlantation.endDate,
					'YYYY-MM-DD',
				);
				let mStart = moment(start);
				let mEnd = moment(end);

				if (mStart.isBefore(plantationStart)) mStart = plantationStart;
				if (mStart.isAfter(plantationEnd)) mStart = plantationEnd;
				let maxEnd = mStart.clone().add(30, 'days');
				if (maxEnd.isAfter(plantationEnd)) {
					maxEnd = plantationEnd;
				}
				if (mEnd.isAfter(maxEnd)) {
					mEnd = maxEnd;
				}
				if (mEnd.isBefore(mStart)) {
					mEnd = mStart;
				}
				const newStart = mStart.toDate();
				const newEnd = mEnd.toDate();
				if (
					!this.initDateNut ||
					!this.endDateNut ||
					this.initDateNut.getTime() !== newStart.getTime() ||
					this.endDateNut.getTime() !== newEnd.getTime()
				) {
					this.datePickerKey = Date.now();
				}
				return [newStart, newEnd];
			},

			assignDates(start, end) {
				this.initDateNut = start;
				this.endDateNut = end;
				this.stepData.initDate = start
					? moment(start).format('YYYY-MM-DD')
					: null;
				this.stepData.endDate = end ? moment(end).format('YYYY-MM-DD') : null;
			},

			shouldRecalculateIrrigation(start, end) {
				return (
					this.stepData.irrigationTable &&
					this.stepData.irrigationTable.length > 0 &&
					start &&
					end
				);
			},

			recalculateIrrigation(start, end) {
				const { timeValuesIrrigation } = getTimeValues(
					moment(start),
					moment(end),
					this.stepData.temporalFrame.id,
				);
			},
			...mapActions('nutritionStepper', [
				'next',
				'back',
				'findSelectedIndex',
				'updateClasses',
				'setStep',
				'setStepDataTemporalFrame',
				'setStepDataInitDate',
				'setStepDataEndDate',
				'setEditingStepData',
			]),
		},
	};
</script>
<style src="./stepper.scss" scoped lang="scss"></style>
